export enum enumDLIDocumentCoBrand {
	'BMFS',
	'Maxfin',
	'SureCard',
	'Uvimba',
	'Q-Card',
	'MycoCard',
	'Classic Ex17',
	'Classic ReIssue',
	'Classic Lite Ex17',
	'Classic Lite ReIssue',
	'Professional',
	'Professional ReIssue',
	'Techno',
	'Techno ReIssue',
	'ePlatinum',
	'ePlatinum ReIssue',
	'Wealth & Reward',
	'Wealth & Reward ReIs',
	'SureCard ReIssue',
	'SureCard ReIssFF',
	'SureCard F',
	'Classic FF',
	'Concession',
	'Concession Max',
	'Concession Volume',
	'StatusMoney F',
	'StatusMoney',
	'StatusMoney FR',
	'StatusMoney ReIssue',
	'Classic Blue',
	'MycoCard ReIssue',
	'Cash Access With PIN',
	'Client Blue',
	'Classic Lite Blue',
	'Wizzit (Ex)',
	'Wizzit ReIssue',
	'Wizzit Business',
	'Wizzit Biz ReIssue',
	'Wizzit (FF)',
	'Wizzit (Blue)',
	'Classic Lite FF',
	'Classic L FF ReIssue',
	'SSTerminalAdmin Card',
	'SSTermSupervisor',
	'ConsumerFair (FF)',
	'ConsumerFair ReIssFF',
	'ConsumerFair (Ex)',
	'ConsumerFair ReIssue',
	'SureE (Blue)',
	'SureE (Ex)',
	'SureE (FF)',
	'MediBucks Ins (FF)',
	'MediBucks Ins (Ex)',
	'Business Group',
	'MediBucks Ins (Blue)',
	'mB Full Spectrum Mer',
	'Business Platinum',
	'Business Silver',
	'Microlender',
	'Microlender Max',
	'SureCard Stock',
	'Medibucks Stock',
	'Medibucks Fixed',
	'mB StandAlone Lite',
	'mB StandAlone Non',
	'Medibucks FixedG',
	'EPA Group',
	'mB Insurance Merchan',
	'Office Account',
	'mB Wallet',
	'Allocated Merchant',
	'mB OMHP Merchant',
	'Flexifusion',
	'Wizzit Reissue FF',
	'Smart D Stock',
	'mB SME Wallet',
	'Classic X',
	'Smart D',
	'Amber Personnel S',
	'Amber Personnel G',
	'Medibucks ExecutiveF',
	'Business Gold',
	'Premium',
	'Premium Lite',
	'Classic Stock',
	'Wizzit Stock',
	'Cash Access Stock',
	'Premium Stock',
	'mB UHAP',
	'Classic MIN FICALite',
	'Classic MIN FullFICA',
	'mB Staff Savings',
	'mB ZOOPP Savings',
	'mB Staff GAP',
	'mB ZOOPP GAP',
	'Savvy 5000',
	'Smart 10000',
	'Smart 10000 FF',
	'mB ZOOPP Group',
	'Reseller Gold',
	'Reseller Platinum',
	'My Smart Cash Stock',
	'My Smart Cash',
	'mB StandAlone Full',
	'Smart D CA',
	'mB Eduvos NF2F',
	'mB Eduvos FF',
	'Amber Rewards Stock',
	'Amber Rewards',
	'dotVault',
	'Intecon Merchant',
	'Universal Business',
	'Mafori FICA Lite',
	'Mafori Full FICA',
	'mB WSU Savings',
	'mB WSU Savings FF',
	'Disbursement Lite',
              }
              
              export namespace enumDLIDocumentCoBrand {
	export function values() {
	  return Object.keys(enumDLIDocumentCoBrand).filter(
	    (type) => isNaN(<any>type) && type !== 'values'
	  );
	}
              }
              